// Copyright (c) StrangeBee 2023

export const DEFAULT_GROUP = 'Default';
